import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
const BASE_URL = "http://localhost:8000/";
const token = Cookies.get("accessToken");
const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    authorization: `Bearer ${token}`,
  },
});
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      Cookies.remove("accessToken");
      Cookies.remove("refreshToken");
      Cookies.remove("user");
      const url = error?.response?.config?.url;
      const urlParts = url.split("/"); // Split the URL by slashes
      const loginPart = "/login".split("/");
      const lastPart = urlParts[urlParts.length - 1]; // Capture the last part of the URL
      const loginLastPart = loginPart[loginPart.length - 1];
      if (lastPart !== loginLastPart) {
        // swalAlerts.showErrorSwal(
        //   "You are not authorized to access this page.",
        //   "Please login to access this page."
        // );
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

function getConfig(config) {
  const token = Cookies.get("accessToken");
  const headers = {
    "Content-Type": "application/json",
    authorization: `Bearer ${token}`,
    ...(config?.headers || {}),
  };
  return { ...(config || {}), headers };
}

const _get = async (url, config = {}) => {
  return apiClient.get(url, getConfig(config));
};

const _delete = async (url, config = {}) => {
  return apiClient.delete(url, getConfig(config));
};

const _put = async (url, data = {}, config = {}) => {
  return apiClient.put(url, data, getConfig(config));
};

const _post = async (url, data = {}, config = {}) => {
  return apiClient.post(url, data, getConfig(config));
};

export const HttpApiClient = {
  get: _get,
  delete: _delete,
  put: _put,
  post: _post,
};
